import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';
import cn from 'classnames';

import { formatDateToEu } from '@/common/lib/date';
import { type LotterySeasonHistoryData } from '@/common/types/lottery';
import { StringSmall } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';

import { SeasonPrizePool } from '../SeasonPrizePool/SeasonPrizePool';

interface ChoseHistorySeasonProps extends LotterySeasonHistoryData {
  handleClick: () => void;
  seasonListIsOpen: boolean;
}

const ChoseHistorySeason: FC<ChoseHistorySeasonProps> = ({
  seasonId,
  totalPrizePool,
  prizePool,
  finishedAt,
  handleClick,
  seasonListIsOpen,
}) => {
  const { t } = useTranslation();

  return (
    <MainButton
      onClick={handleClick}
      className="!h-[40px] shrink-0 !w-[275px] mb-6"
      text=""
    >
      <div className="flex justify-center gap-4 items-center">
        <StringSmall weight="bold" className="!text-[14px]">
          {t('Draw №{{seasonId}}', { seasonId })}
        </StringSmall>
        <StringSmall weight="bold" className="!text-[14px]">
          <SeasonPrizePool
            prizePool={prizePool}
            totalPrizePool={totalPrizePool}
          />
        </StringSmall>
        <StringSmall weight="bold" className="!text-[14px]">
          {formatDateToEu(finishedAt)}
        </StringSmall>
        <ChevronIcon
          className={cn(
            '!text-white w-[10px] transition-all',
            seasonListIsOpen ? 'rotate-90' : '-rotate-90',
          )}
        />
      </div>
    </MainButton>
  );
};

export { ChoseHistorySeason };
